import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import DateField from '../common/TextField/dateTime';
import DropDown from "../common/SearchableSelect";
import TextField from "../common/TextField/withLabel";
import * as Toasts from '../common/Toastify';
import { clearFilter, firstPage, loadPaymentShiftsCoverageListings, updateFilterFields } from './action';
import { shiftsCoverageSelector } from './selector';
import MultiSelect from "../common/TextField/dropDown";
import { fetchDepsUnits } from "../Login/action";
// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    const dispatch = useDispatch();
    const config = useConfiguration();
    const storage = useSessionStorage();
    const login = storage.getItem('login');
    const depsUnitsRef = useRef();
    const { filterFields, masterDatas } = useSelector(shiftsCoverageSelector);
    const depsUnitsMaster = useSelector(store => store.login.depsUnitsMaster);

    const updateLocation = (target) => {
        const value = target.value;
        dispatch(updateFilterFields('location', value));
    };

    const updateFromDate = (target) => {
        const value = target.value;
        dispatch(updateFilterFields('fromDate', value));
    };
    const updateToDate = (target) => {
        const value = target.value;
        dispatch(updateFilterFields('toDate', value));
    };
    const updateSearchText = (target) => {
        const value = target.value;
        dispatch(updateFilterFields('searchText', value));
    };
    const searchFilter = (e) => {
        e.preventDefault();
        if (!filterFields.fromDate && !filterFields.toDate) {
            dispatch(loadPaymentShiftsCoverageListings({ url: config.baseUrl, empId: login.employerUniqueId, pageToLoad: 1 }));
        } else if (filterFields.fromDate && !filterFields.toDate) {
            Toasts.warning('Please Select "To Date"');
        } else if (!filterFields.fromDate && filterFields.toDate) {
            Toasts.warning('Please Select "From Date"');
        } else if (Date.parse(filterFields.toDate) < Date.parse(filterFields.fromDate)) {
            Toasts.warning('Please Select "To Date" should be greater than "From Date"');
        } else {
            dispatch(loadPaymentShiftsCoverageListings({ url: config.baseUrl, empId: login.employerUniqueId, pageToLoad: 1 }));
        }
    }

    const locationChangeHandler = e => {
        const {action,value,name} = e;
        let copyDepsUnits = [...filterFields.location];
        if(action === "add"){
            copyDepsUnits.push(value)
        } else if(action === "remove"){
            copyDepsUnits = copyDepsUnits?.filter(item => item?.id !== value?.id)
        }
        dispatch(updateFilterFields('location', copyDepsUnits));
    }



    const depsUnitsChangeHandler = e => {
        const {action,value,name} = e;
        let copyDepsUnits = [...filterFields?.department];
        if(action === "add"){
            copyDepsUnits.push(value)
        } else if(action === "remove"){
            copyDepsUnits = copyDepsUnits?.filter(item => item?.id !== value?.id)
        }
        dispatch(updateFilterFields('department', copyDepsUnits));
        // dispatch(setCreationValue({name,value:copyDepsUnits}))
    }
    useEffect(() => {
        if (config?.baseUrl && depsUnitsMaster?.length === 0) {
            dispatch(fetchDepsUnits({baseUrl: config?.baseUrl}));
          }
        return () => {
            depsUnitsRef.current.resetSelectedValues();
          }
    },[config?.baseUrl])
    return (
            <>
                 <div     style={{
            display: "grid",
            gridTemplateColumns: "repeat(5,minmax(0,1fr))",
            rowGap: "0.5rem",
            columnGap: "1.75rem",
          }}>
                <MultiSelect name={'filterLocation'}
                    label={"Location Name"}
                    id={'filterLocation'}
                    options={masterDatas.locationList} multiple={true}
                    value={filterFields.location}
                    updateValue={locationChangeHandler} isObject={true}
                    showArrow={true} divClass={"w-100"} />
                      <MultiSelect
                    name={"department"}
                    id={'department'}
                    label ="Departments"
                    value={filterFields?.department}
                    options={depsUnitsMaster}
                    multiple={true}
                    updateValue={depsUnitsChangeHandler}
                    isObject={true}
                    divClass={"w-100"}
                        // errors={props.errors ? props.errors["depsUnits"] : []}
                    multiselectRef={depsUnitsRef}
          />
                <DateField name={"fromDate"}
                    label={"From Date"}
                    id={"fromDate"}
                    value={filterFields.fromDate}
                    updateValue={updateFromDate}
                    //    divClass={"date-time-field"}
                    includeTime={false} divClass={"w-100"}/>
                <DateField name={"toDate"}
                    label={"To Date"}
                    id={"toDate"}
                    value={filterFields.toDate}
                    updateValue={updateToDate}
                    //    divClass={"date-time-field"}
                    includeTime={false} divClass={"w-100"} />
                <TextField name={"searchText"}
                    label={"Search Text"}
                    value={filterFields.searchText}
                    updateValue={updateSearchText}
                    divClass={"w-100"} />
                </div>
                <div className={"col-md-3 col-lg-3 apply-button"}  >
                    <button className={"btn btn-outline-primary button-margin"} onClick={(event) => {
                        event.preventDefault();
                        depsUnitsRef.current.resetSelectedValues()
                        dispatch(clearFilter()).then(() => {
                            dispatch(loadPaymentShiftsCoverageListings({ url: config.baseUrl, empId: login.employerUniqueId }));
                        })
                    }}>
                        Clear
                    </button>
                    <button className={"btn btn-primary"} onClick={(event) => { searchFilter(event) }}>Search</button>
                </div>
            </>
    )
}
